module.exports = __webpack_public_path__ + "img/ic_notification_multiple_play.95a2c3be.png";